import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DataService} from '../data.service';
import { Observable } from 'rxjs';
import { FRTSyncadaIFFStagingEntity } from 'src/app/shared/common-components/common-structure';
@Injectable({
  providedIn: 'root'
})
export class FrtSyncadaInvoicesService extends DataService {

  private baseURI = this.apiUri + '/frtsyncadaiffstaging';
  // private iffMasterXlsxURI = this.publicApiUri + '/iffMasterListxlsx';
 
  getAllFrtSycadaShipmentInvoices():Observable<FRTSyncadaIFFStagingEntity> {      
    const frtSycadaShipmentInvoices = this.baseURI + '/getallinvoices';
    this.setUri(frtSycadaShipmentInvoices);
    return this.get();
  }
}


